import React from "react";
import { Link } from "react-router-dom";

const ConsultingLayout = ({ service }) => {
    return (
        <div className="bg-white text-gray-900">

            {/* ================= HERO ================= */}
            <section
                className="relative min-h-[80vh] flex items-center"
                style={{
                    backgroundImage:
                        "url(/images/conselting/cn2.jfif)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="absolute inset-0 bg-black/60" />
                <div className="relative w-full px-6 md:px-16 lg:px-24 py-24 text-white text-left">
                    <h1 className="text-5xl md:text-6xl font-bold mb-6">
                        Enterprise Consulting Services
                    </h1>
                    <p className="text-xl max-w-3xl text-gray-200 mb-8">
                        Shape strategy, drive transformation, and unlock sustainable
                        business value with technology-led consulting.
                    </p>
                    <Link
                        to="/contact"
                        className="inline-block bg-orange-500 hover:bg-orange-600 px-8 py-4 rounded-lg font-semibold"
                    >
                        Speak to Our Consultants
                    </Link>
                </div>
            </section>

            {/* ================= VALUE STRIP ================= */}
            <section className="border-b">
                <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-3 gap-6 text-center">
                    <div>
                        <h3 className="font-semibold text-lg">Business-First Approach</h3>
                        <p className="text-sm text-gray-600">
                            Strategy aligned to measurable outcomes
                        </p>
                    </div>
                    <div>
                        <h3 className="font-semibold text-lg">Deep Domain Expertise</h3>
                        <p className="text-sm text-gray-600">
                            Industry-specific consulting frameworks
                        </p>
                    </div>
                    <div>
                        <h3 className="font-semibold text-lg">Execution Excellence</h3>
                        <p className="text-sm text-gray-600">
                            From roadmap to real-world impact
                        </p>
                    </div>
                </div>
            </section>

            {/* ================= CONSULTING OVERVIEW ================= */}
            <section className="max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-2 gap-12 items-center">
                <div>
                    <h2 className="text-4xl font-bold mb-6">
                        Strategy-Led Digital Transformation
                    </h2>
                    <p className="text-gray-600 mb-6">
                        Our consulting services help enterprises navigate complexity,
                        modernize operating models, and create future-ready organizations.
                    </p>
                    <ul className="space-y-3 text-gray-700">
                        <li>✔ Digital & business transformation strategy</li>
                        <li>✔ Experience-driven transformation</li>
                        <li>✔ Operating model redesign</li>
                        <li>✔ Technology & platform advisory</li>
                    </ul>
                </div>
                <img
                    src="/images/conselting/cn2.jfif"
                    alt="Consulting strategy"
                    className="rounded-xl"
                />
            </section>

            {/* ================= KEY CONSULTING AREAS ================= */}
            <section className="bg-gray-50">
                <div className="max-w-7xl mx-auto px-6 py-20">
                    <h2 className="text-4xl font-bold mb-12">
                        Our Consulting Capabilities
                    </h2>
                    <div className="grid md:grid-cols-3 gap-8">
                        {[
                            {
                                title: "Innovation Strategy",
                                desc: "Identify growth opportunities and innovation levers using design-led thinking."
                            },
                            {
                                title: "Experience Transformation",
                                desc: "Reimagine customer and employee journeys across digital touchpoints."
                            },
                            {
                                title: "Next-Gen Business Transformation",
                                desc: "Build agile, data-driven, and technology-enabled enterprises."
                            },
                            {
                                title: "Change Management",
                                desc: "Drive adoption and cultural alignment for sustainable change."
                            },
                            {
                                title: "Technology Advisory",
                                desc: "Select the right platforms, architectures, and ecosystems."
                            },
                            {
                                title: "Enterprise Roadmaps",
                                desc: "Translate vision into actionable, phased execution plans."
                            },
                        ].map((item) => (
                            <div
                                key={item.title}
                                className="bg-white p-8 rounded-xl shadow hover:shadow-lg transition"
                            >
                                <h3 className="font-semibold text-lg mb-2">
                                    {item.title}
                                </h3>
                                <p className="text-sm text-gray-600">
                                    {item.desc}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ================= ENGAGEMENT MODEL ================= */}
            <section className="max-w-7xl mx-auto px-6 py-20">
                <h2 className="text-4xl font-bold mb-12">
                    How We Engage
                </h2>
                <div className="grid md:grid-cols-3 gap-8">
                    {[
                        "Assess & Diagnose",
                        "Define Strategy & Roadmap",
                        "Enable & Execute",
                    ].map((step, index) => (
                        <div key={step} className="border rounded-xl p-6">
                            <div className="text-indigo-600 font-bold text-2xl mb-2">
                                0{index + 1}
                            </div>
                            <h3 className="font-semibold mb-2">{step}</h3>
                            <p className="text-sm text-gray-600">
                                Structured, outcome-oriented consulting approach tailored to
                                your enterprise context.
                            </p>
                        </div>
                    ))}
                </div>
            </section>

            {/* ================= CLIENT IMPACT ================= */}
            <section className="bg-gray-900 text-white">
                <div className="max-w-7xl mx-auto px-6 py-20">
                    <h2 className="text-4xl font-bold mb-10">
                        Consulting Impact
                    </h2>
                    <div className="grid md:grid-cols-3 gap-8">
                        {[
                            "30% faster transformation execution",
                            "Improved stakeholder alignment",
                            "Clear ROI-driven roadmaps",
                        ].map((item) => (
                            <div key={item} className="bg-gray-800 p-6 rounded-xl">
                                <p className="text-lg font-semibold">{item}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ================= WHY TECHSPR ================= */}
            <section className="max-w-7xl mx-auto px-6 py-20">
                <h2 className="text-4xl font-bold mb-12">
                    Why TECHSPR Consulting
                </h2>
                <div className="grid md:grid-cols-3 gap-8">
                    {[
                        "Industry-aligned consulting frameworks",
                        "Technology-backed strategic advisory",
                        "Proven enterprise transformation track record",
                    ].map((item) => (
                        <div key={item} className="p-6 border rounded-xl">
                            <h3 className="font-semibold mb-2">{item}</h3>
                            <p className="text-sm text-gray-600">
                                Helping leaders make confident, future-ready decisions.
                            </p>
                        </div>
                    ))}
                </div>
            </section>

            {/* ================= CTA ================= */}
            <section className="bg-indigo-700 text-white">
                <div className="max-w-7xl mx-auto px-6 py-20 text-center">
                    <h2 className="text-4xl font-bold mb-4">
                        Ready to Transform with Confidence?
                    </h2>
                    <p className="text-indigo-100 mb-8">
                        Partner with TECHSPR Consulting to turn strategy into results.
                    </p>
                    <Link
                        to="/contact"
                        className="inline-block bg-white text-indigo-700 px-8 py-4 rounded-lg font-semibold"
                    >
                        Contact Us
                    </Link>
                </div>
            </section>

        </div>
    );
};

export default ConsultingLayout;
